import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';
import { ANY_EDITION, AppsService } from '../../../../../../data-services/apps.service';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AccountOptionsDisplayService implements DataFilterDisplayService {
  constructor(private appsService: AppsService) {}

  getDisplay(accountIds: string[]): Observable<string> {
    return combineLatest(
      accountIds.map((id) => {
        // TODO filters for active accounts currently supports the base app IDs only - does not support specific edition IDs
        return this.appsService.getProductName({ appId: id, editionId: ANY_EDITION }, false, false);
      }),
    ).pipe(
      take(1),
      map((names) => names.join(', ')),
      map((result) => `<b>${result}</b>`),
    );
  }
}
